// This file was automatically generated from appchart.dialog.cqmDashboardDialog.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.cqmDashboardDialog');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.cqmDashboardDialog.layout = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="cqm-dashboard-toolbar-top"><div class="el8StandardFontSize" style="display:inline-block; float:right; margin:10px"><a id="cqm-dashboard-extractor-output-link" href="" target="_blank" rel="noopener" class="mr15">Codes extracted from chart</a><a id="cqm-dashboard-calculator-output-link" href="" target="_blank" rel="noopener">Raw calculator output</a></div><div class="ebs-isolate el8TextareaWrap" style="display:inline-block"><input id="cqm-dashboard-measures-filter" placeholder="Filter..." /></div><div class="ebs-isolate el8TextareaWrap" style="display:inline-block;border:0"><select id="cqm-dashboard-measures-year"><option value="2024">2024</option><option value="2023">2023</option><option value="2022">2022</option><option value="2021">2021</option><option value="2020">2020</option><option value="2019">2019</option><option value="2018">2018</option><option value="2017">2017</option></select></div></div><div style="position:absolute; width:100%; top:36px; bottom:0px; overflow:scroll"><div id="cqm-dashboard-measures-list"></div></div><div id="cqm-dashboard-refresh-status" class="el8NormalWeight el8StandardFontSize" style="position:absolute; background-color:#fff; right:10px; top:36px; padding:5px; border:1px solid #000; border-radius:2px"><span class="el8Loading" style="width:16px; height:16px; display:inline-block;">&nbsp;</span> Updating</div><div id="cqm-dashboard-refresh-status-error" class="el8NormalWeight el8StandardFontSize" style="position:absolute; background-color:#fff; right:10px; top:36px; padding:5px; border:1px solid #000; border-radius:2px;color:red;"><span class="el8Loading" style="width:16px; height:16px; display:inline-block;">&nbsp;</span> Updating error, retrying...</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.cqmDashboardDialog.measureSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="cqm-dashboard-measure-wrapper-', soy.$$escapeHtml(opt_data.id), '" data-name="', soy.$$escapeHtml(opt_data.results.display_name), '"><h4 id="cqm-dashboard-measure-header-', soy.$$escapeHtml(opt_data.id), '" class="el8SectionHeader"><span id="cqm-dashboard-measure-status-', soy.$$escapeHtml(opt_data.id), '" class="el8Elt"><span class="el8DownArrowIcon"></span></span>', soy.$$escapeHtml(opt_data.results.display_name), ' (<a href="/quality_measures/definition/', soy.$$escapeHtml(opt_data.id), '/" target="_blank" rel="noopener">', soy.$$escapeHtml(opt_data.results.measure_code), '</a>)</h4><div class="mb10" id="cqm-dashboard-measure-details-', soy.$$escapeHtml(opt_data.id), '"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.cqmDashboardDialog.populationStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="ml50 mt15 mb15 mr10 el8NormalWeight el8StandardFontSize">', (opt_data.status) ? '<div class="el8CheckmarkIcon" style="margin-left:-15px;"></div>' : '<div class="el8CheckmarkIcon" style="background-position:-140px -85px; margin-left:-15px;"></div>', '<span style="text-transform:capitalize; font-weight:bold;">', soy.$$escapeHtml(opt_data.populationName), '</span> <span style="margin-left:6px;">', soy.$$escapeHtml(opt_data.summary), '</span></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.cqmDashboardDialog.populationElement = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="ml75 mt15 mb5 mr10 el8NormalWeight el8StandardFontSize">', (opt_data.status) ? '<div class="el8CheckmarkIcon" style="margin-left:-15px;"></div>' : '<div class="el8CheckmarkIcon" style="background-position:-140px -85px; margin-left:-15px;"></div>', '<span>', opt_data.summary, '</span></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.cqmDashboardDialog.matchedItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="ml75 mt5 mb5 mr10 pad5 el8NormalWeight el8StandardFontSize" style="background-color: #ffd"><div style="font-style:italic">Chosen ', soy.$$escapeHtml(opt_data.name), ':</div><div style="font-family:monospace;">', soy.$$escapeHtml(opt_data.item), '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.cqmDashboardDialog.unmatchedItems = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="ml75 mt5 mb5 mr10 pad5 el8NormalWeight el8StandardFontSize"><div style="font-style:italic">Not chosen for ', soy.$$escapeHtml(opt_data.name), ':</div>');
  var itemList1399 = opt_data.items;
  var itemListLen1399 = itemList1399.length;
  for (var itemIndex1399 = 0; itemIndex1399 < itemListLen1399; itemIndex1399++) {
    var itemData1399 = itemList1399[itemIndex1399];
    output.append('<div style="font-family:monospace; color:#a2a2a2">', soy.$$escapeHtml(itemData1399), '</div>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.cqmDashboardDialog.itemDeadline = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="ml75 mt5 mb5 mr10 pad5 el8NormalWeight el8StandardFontSize"><div style="font-style:italic"><img src="/static/images/calendar_16x15.png" style="vertical-align:bottom; margin-right:5px;">', (opt_data.currentlySatisfied) ? '<span style="color:#67bf5c">' : '<span style="color:#ffbb78">', soy.$$escapeHtml(opt_data.deadlineString), '</span></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.cqmDashboardDialog.itemDetailsUnavailable = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="ml75 mt5 mb5 mr10 pad5 el8NormalWeight el8StandardFontSize"><div style="font-style:italic">Items for ', soy.$$escapeHtml(opt_data.name), ' are not exposed by calculator.</div></div>');
  if (!opt_sb) return output.toString();
};
